/* eslint-disable no-template-curly-in-string */
import * as yup from 'yup';

export const emailSchema = yup.string().email('Invalid email address');

export const passwordSchema = yup
  .string()
  .min(8, 'Password must be at least ${min} characters')
  .max(255, 'Password must be at most ${max} characters');
